/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IEscrowInvitationQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type IEscrowInvitationQuery = {
  __typename?: 'Query';
  escrowInvitation: {
    __typename?: 'EscrowInvitation';
    id: string;
    status: Types.InvitationStatusEnum;
    appName: string;
    companyName: string;
    partyType: string;
    policy: { __typename?: 'EscrowInvitationPolicy'; accept: boolean; reject: boolean; update: boolean };
    escrow:
      | {
          __typename?: 'ContinuityEscrow';
          id: string;
          productType: Types.AppProductTypeEnum;
          beneficiary?: {
            __typename?: 'Beneficiary';
            id: string;
            companyName?: string | null;
            companyWebsite?: string | null;
          } | null;
          depositor?: {
            __typename?: 'Depositor';
            id: string;
            companyName?: string | null;
            companyWebsite?: string | null;
          } | null;
        }
      | {
          __typename?: 'SaasEscrow';
          id: string;
          productType: Types.AppProductTypeEnum;
          beneficiary?: {
            __typename?: 'Beneficiary';
            id: string;
            companyName?: string | null;
            companyWebsite?: string | null;
          } | null;
          depositor?: {
            __typename?: 'Depositor';
            id: string;
            companyName?: string | null;
            companyWebsite?: string | null;
          } | null;
        }
      | {
          __typename?: 'SoftwareEscrow';
          id: string;
          productType: Types.AppProductTypeEnum;
          beneficiary?: {
            __typename?: 'Beneficiary';
            id: string;
            companyName?: string | null;
            companyWebsite?: string | null;
          } | null;
          depositor?: {
            __typename?: 'Depositor';
            id: string;
            companyName?: string | null;
            companyWebsite?: string | null;
          } | null;
        };
  };
};

export const EscrowInvitationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'escrowInvitation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'escrowInvitation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'escrowInvitationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'partyType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accept' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reject' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'escrow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'beneficiary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'depositor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IEscrowInvitationQuery, IEscrowInvitationQueryVariables>;
